import { useId } from 'react';

type TomorrowTasksCalendarWatermarkProps = {
  className?: string;
};

/** Decorative calendar watermark for helper home tomorrow-tasks action card. */
export const TomorrowTasksCalendarWatermark = ({
  className = '',
}: TomorrowTasksCalendarWatermarkProps) => {
  const uid = useId().replace(/:/g, '');
  const lightCalendarId = `tomorrowTasksCalendar-light-${uid}`;
  const darkCalendarId = `tomorrowTasksCalendar-dark-${uid}`;

  const renderCalendar = (
    calendarId: string,
    colors: {
      bodyStroke: string;
      bodyFill: string;
      headerFill: string;
      ringStroke: string;
      ringFill: string;
      grid: string;
      accent: string;
    },
  ) => (
    <g id={calendarId}>
      <rect
        x="30"
        y="40"
        width="140"
        height="130"
        rx="18"
        fill={colors.bodyFill}
        stroke={colors.bodyStroke}
        strokeWidth="10"
      />
      <rect x="30" y="40" width="140" height="36" rx="18" fill={colors.headerFill} />
      <rect x="30" y="58" width="140" height="18" fill={colors.headerFill} />
      <rect x="54" y="24" width="14" height="28" rx="5" fill={colors.ringFill} stroke={colors.ringStroke} strokeWidth="6" />
      <rect x="132" y="24" width="14" height="28" rx="5" fill={colors.ringFill} stroke={colors.ringStroke} strokeWidth="6" />
      <line x1="52" y1="92" x2="148" y2="92" stroke={colors.grid} strokeWidth="4" />
      <line x1="52" y1="118" x2="148" y2="118" stroke={colors.grid} strokeWidth="4" />
      <line x1="52" y1="144" x2="148" y2="144" stroke={colors.grid} strokeWidth="4" />
      <line x1="78" y1="84" x2="78" y2="156" stroke={colors.grid} strokeWidth="4" />
      <line x1="104" y1="84" x2="104" y2="156" stroke={colors.grid} strokeWidth="4" />
      <line x1="130" y1="84" x2="130" y2="156" stroke={colors.grid} strokeWidth="4" />
      <rect x="58" y="100" width="14" height="12" rx="2" fill={colors.accent} opacity="0.55" />
      <rect x="84" y="100" width="14" height="12" rx="2" fill={colors.accent} opacity="0.55" />
      <rect x="110" y="100" width="14" height="12" rx="2" fill={colors.accent} opacity="0.85" />
      <rect x="136" y="100" width="14" height="12" rx="2" fill={colors.accent} opacity="0.55" />
      <rect x="58" y="126" width="14" height="12" rx="2" fill={colors.accent} opacity="0.55" />
      <rect x="84" y="126" width="14" height="12" rx="2" fill={colors.accent} opacity="0.55" />
    </g>
  );

  return (
    <svg
      className={className}
      width="200"
      height="200"
      viewBox="0 0 200 200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <defs>
        {renderCalendar(lightCalendarId, {
          bodyStroke: '#D97706',
          bodyFill: '#FEF3C7',
          headerFill: '#FDE68A',
          ringStroke: '#F59E0B',
          ringFill: '#FEF3C7',
          grid: '#FCD34D',
          accent: '#F59E0B',
        })}
        {renderCalendar(darkCalendarId, {
          bodyStroke: '#B45309',
          bodyFill: '#451A03',
          headerFill: '#78350F',
          ringStroke: '#D97706',
          ringFill: '#451A03',
          grid: '#92400E',
          accent: '#F59E0B',
        })}
      </defs>

      <g className="dark:hidden">
        <use href={`#${lightCalendarId}`} opacity="0.28" />
      </g>
      <g className="hidden dark:block">
        <use href={`#${darkCalendarId}`} opacity="0.32" />
      </g>
    </svg>
  );
};
